<template>
  <div class="success-content">
    <div class="info">
      <div class="item">
        <div class="title">借款金额</div>
        <div class="value">{{ amount | currency }}</div>
      </div>
      <template v-if="onlyOneBill">
        <div class="item">
          <div class="title">借款期限</div>
          <div class="value">{{result.dueTime}}个月</div>
        </div>
        <div class="item">
          <div class="title">借款日期</div>
          <div class="value">{{formatDate(result.loanDate)}}</div>
        </div>
      </template>
      <template v-else>
        <div class="item">
          <div class="title">到账时间</div>
          <div class="value">最快5分钟，具体以银行流水为准</div>
        </div>
      </template>
      <div class="item">
        <div class="title">放款借据</div>
        <div class="value">
          <div v-for="billNo in orderNumbers" :key="billNo" class="order">
            {{ billNo }}
          </div>
        </div>
      </div>
    </div>
    <template v-if="onlyOneBill">
      <div class="action" @click="backHome">
        返回首页
      </div>
    </template>
    <template v-else>
      <div class="action" @click="toDetail">
        查看详情
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    amount () {
      if (this.result.processLoanInfos) {
        return this.result.processLoanInfos.reduce((total, item) => total + item.applyAmount, 0)
      } else {
        return this.result.applyAmount
      }
    },
    orderNumbers () {
      if (this.result.processLoanInfos) {
        return this.result.processLoanInfos.map(item => item.platBillNo)
      } else {
        return [this.result.platBillNo]
      }
    },
    onlyOneBill () {
      const infos = this.result.processLoanInfos || []
      return infos.length <= 1
    }
  },
  methods: {
    toDetail () {
      this.$router.push({
        path: '/repayment/history',
        query: {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  .info {
    background: #FAFAFA;
    border-radius: 20px;
    padding: 40px 40px 27px 40px;
    width: 100%;
    .item {
      display: flex;
      flex-direction: row;
      margin-bottom: 13px;
      .title {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        width: 162px;
      }
      .value {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
        display: flex;
        flex-direction: column;
        word-break: break-all;
        width: 448px;
      }
    }
  }
  .action {
    width: 360px;
    height: 80px;
    border-radius: 40px;
    border: 2px solid #FF4633;
    margin-top: 40px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF4633;
    line-height: 80px;
    text-align: center;
  }
}
</style>